import { PayloadAction } from '@reduxjs/toolkit';
import { BottomSheetState } from '@reducers/v2/bottomSheet/bottomSheet.slice';

export const setPreCloseActionAction = (state: BottomSheetState, action: PayloadAction<(() => void) | null>) => {
	state.preCloseAction = action.payload;
};
